@if (showPreviousImageSelector) {
	<app-previous-image-selector
		table="client_text"
		column="logo_uri"
		(onSelectImageUrl)="selectLogoUri($event)"
		(onClose)="showPreviousImageSelector = false"
	></app-previous-image-selector>
}

<form [formGroup]="form" (ngSubmit)="onSubmit()">
	<app-form-title [editMode]="client !== undefined" model="Client"></app-form-title>

	<app-name-field [fg]="form" formGroupOrControlName="name"></app-name-field>

	<app-text-field
		[fg]="form"
		formGroupOrControlName="logoUri"
		label="Logo URI"
		[enableUpload]="true"
		accept="image/*"
		[multiple]="false"
		[directory]="false"
		[enablePrevious]="true"
		(showPrevious)="showPreviousImageSelector = true"
	></app-text-field>

	<app-html-description-field
		[fg]="form"
		formGroupOrControlName="descriptionHtml"
		label="Description"
	></app-html-description-field>

	<app-text-field [fg]="form" formGroupOrControlName="descriptionShort" label="Short Description"></app-text-field>

	<app-text-field [fg]="form" formGroupOrControlName="subdomain" label="Subdomain"></app-text-field>

	<app-account-type-field
		[fg]="form"
		formGroupOrControlName="accountType"
		label="Account Type"
	></app-account-type-field>

	<app-checkbox-field
		[fg]="form"
		formGroupOrControlName="allowSectionSelfRostering"
		label="Allow Section Self Rostering"
	></app-checkbox-field>

	<app-checkbox-field
		[fg]="form"
		formGroupOrControlName="allowCleverSso"
		label="Allow Clever SSO"
	></app-checkbox-field>

	@if (form.get('allowCleverSso')?.value) {
		<app-text-field
			[fg]="form"
			formGroupOrControlName="cleverSsoDistrictId"
			label="Clever District ID"
		></app-text-field>
	}

	<app-checkbox-field
		[fg]="form"
		formGroupOrControlName="allowEduskills"
		label="Allow Eduskills"
	></app-checkbox-field>

	@if (form.get('allowEduskills')?.value) {
		<app-text-field
			[fg]="form"
			formGroupOrControlName="eduskillsDistrictId"
			label="Eduskills District ID"
		></app-text-field>
	}

	<app-textarea-field [fg]="form" formGroupOrControlName="dataJson" label="Data JSON"></app-textarea-field>

	<div class="buttons">
		<button nz-button nzType="primary" type="submit" [disabled]="form.invalid">Submit</button>
		<button nz-button type="submit" (click)="clear(); $event.preventDefault()">Clear</button>
	</div>
</form>
